const CryptoJS = require('crypto-js');

export const userDetails = () => {
  // Decrypt
  const token = localStorage.getItem('token');
  const bytes = CryptoJS.AES.decrypt(token, 'retApp-web-string@#20');
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};
